<template>
  <div
    class="alert text-white font-weight-bold"
    role="alert"
    :class="color === 'error' ? `bg-white rounded border-danger alert-control-${size}` : getClasses(color, dismissible, size)"
  >
    <span class="alert-icon">
      <i :class="getIcon(icon)" />
    </span>
    <span :class="color === 'error' ? 'text-danger' : 'alert-text'">
      &nbsp;
      <slot />
    </span>
    <button
      v-if="dismissible"
      type="button"
      class="btn-close d-flex justify-content-center align-items-center"
      data-bs-dismiss="alert"
      aria-label="Close"
      @click="$emit('close-alert')"
    >
      <span aria-hidden="true" class="text-lg font-weight-bold">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "argon-alert",
  props: {
    color: {
      type: String,
      default: "success",
    },
    size: {
      type: String,
      default: "default",
    },
    icon: String,
    dismissible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getClasses: (color, dismissible, size) => {
      let colorValue, dismissibleValue, sizeValue;

      sizeValue = size ? `alert-control-${size}` : null;

      colorValue = color ? `alert-${color}` : null;

      dismissibleValue = dismissible ? "alert-dismissible fade show" : null;

      return `${colorValue} ${dismissibleValue} ${sizeValue}`;
    },
    getIcon: (icon) => (icon ? icon : null),
  },
};
</script>
